import { Component, Input } from "@angular/core";
import { PurchaseOrder } from "./purchase-order";

@Component({
  selector: 'purchase-order',
  templateUrl: './purchase-order.component.html'
})
export class PurchaseOrderComponent {
  @Input()
  purchaseOrder!: PurchaseOrder
}